// Reusable component for displaying nearby areas
import React, { useState, useEffect } from 'react';
import { islandScopedDocumentFilter, sanityFetch } from '../../lib/sanity';

const NearbyAreas = ({ currentAreaTitle, regionTitle, regionSlug, onAreaSelect }) => {
  const [nearbyAreas, setNearbyAreas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNearbyAreas = async () => {
      if (!regionSlug) return;
      
      try {
        const query = `*[_type == "area" && ${islandScopedDocumentFilter()} && region->slug.current == $regionSlug]{
          _id,
          title,
          slug,
          oneLiner,
          heroImage{asset->{url}, alt}
        }`;
        
        const areas = await sanityFetch(query, { regionSlug });
        
        // Filter out current area
        const filtered = areas.filter(area => area.title !== currentAreaTitle);
        setNearbyAreas(filtered);
      } catch (error) {
        console.error('Error fetching nearby areas:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchNearbyAreas();
  }, [regionSlug, currentAreaTitle]);

  if (loading) {
    return (
      <div className="mb-12">
        <h2 className="text-xl font-semibold mb-2">Nearby Areas in {regionTitle}</h2>
        <div className="text-white/70">Loading nearby areas...</div>
      </div>
    );
  }

  if (nearbyAreas.length === 0) {
    return null;
  }

  return (
    <div className="mb-6">
      <h2 className="text-xl font-bold mb-2 text-white">Nearby Areas in {regionTitle}</h2>
      <div className="grid md:grid-cols-3 gap-6">
        {nearbyAreas.map((area) => (
          <button
            key={area._id}
            onClick={() => onAreaSelect && onAreaSelect(area.title)}
            className="border border-gray-600 rounded-lg overflow-hidden group hover:text-green-300 transition-colors cursor-pointer text-left"
          >
            {/* Area Name Header */}
            <div className="p-4 bg-white/5">
              <h3 className="text-xl font-semibold text-white group-hover:text-green-300 transition-colors">{area.title}</h3>
            </div>
            
            {/* Hero Image */}
            <div className="w-full h-48">
              {area.heroImage?.asset?.url ? (
                <img
                  src={area.heroImage.asset.url}
                  alt={area.heroImage.alt || area.title}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full bg-gray-700 flex items-center justify-center">
                  <span className="text-gray-400">{area.title}</span>
                </div>
              )}
            </div>
            
            {/* Description */}
            <div className="p-4">
              <p className="text-white/90 group-hover:text-green-300 transition-colors text-sm">
                {area.oneLiner}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default NearbyAreas;
